export default __webpack_public_path__ + "static/media/info-black.be922693.svg";